<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <!-- <div class="card-header"></div> -->

                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Novo Peso
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">{{ item.peso | formatBRL }} Kg</td>
                                    <td
                                        :data-label="headers[2].name"
                                    >{{ item.data | formatDate('DD/MM/YYYY') }}</td>

                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="far fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../../facade/facade";

const facade = new Facade();

export default {
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Peso", key: "peso" },
                { name: "Data", key: "data" }
            ],
            filter: {
                realizado: ""
            },
            model: {},
            list: {},
            size: 20,
            page: 0,
            order: ["id", "ASC"]
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        back() {
            this.$router.push({
                name: "list-pet",
                params: {
                    idCliente: this.$route.params.idCliente
                }
            });
        },
        clean() {
            this.filter = {
                realizado: null
            };
        },
        create() {
            this.$router.push({ name: "new-weight-pet" });
        },
        edit(id) {
            this.$router.push({
                name: "edit-weight-pet",
                params: {
                    id: this.$route.params.id,
                    idWeight: id
                }
            });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteWeight(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);

                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o peso."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },
        fetchData(page) {
            let vm = this;
            vm.page = page;

            this.$loading.show(true);
            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order,
                    idPet: this.$route.params.id
                }
            };

            let ret = facade.listWeight(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error("Erro!", "Ocorreu um problema ao listar .");
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?3a07b93b